const Globals = {
    cancelModificationChanges: (booking, store, router) => {
        if (booking && booking.reference) {
            let path = '/user/bookings/' + booking.reference;

            if (booking.can_be_modified) {
                path += '/edit';
            }

            if (window.location.search) {
                path += window.location.search;
            }

            const urlParams = new URLSearchParams(window.location.search);
            const bookingToken = urlParams.get('t');

            if (bookingToken) {
                // If there's a booking token it means the user is a guest, so we need to
                // redirect to the guest bookings route
                path = path.replace('/user/bookings', '/guest/bookings');
            }

            // First, select the booking mod cancellation request, to delete the ongoing modification quote.
            // Then wait for the request to finish before redirecting.
            store
                .dispatch('cancelBookingModification', {
                    bookingReference: booking.reference,
                })
                .then(() => {
                    router.push({
                        path,
                    });
                    router.go(0);
                })
                .catch((error) => {
                    router.push({
                        path,
                    });
                    router.go(0);
                });
        }
    },

    convertLocaleForMoments: (locale = 'en') => {
        const localeMap = {
            ba: 'bs',
            cn: 'zh-cn',
            dk: 'da',
            en: 'en-gb',
            gr: 'el',
            jp: 'ja',
            me: 'sr',
            mt: 'en-gb',
            mx: 'es-mx',
            rs: 'sr',
            se: 'sv',
            tw: 'zh-tw',
        };

        return localeMap[locale] || locale;
    },

    formatTimeForLocale: (time, locale = 'en') => {
        if (!time) {
            return '';
        }

        const target = new Date('1970-01-01T' + time);

        if (Number.isNaN(target.getTime())) {
            return time;
        }

        return target.toLocaleString(Globals.convertLocaleForMoments(locale), {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });
    },

    getBookingModificationsPath: (reference, canBeModified = false) => {
        let path = '/user/bookings/' + reference;

        if (canBeModified) {
            path += '/edit';
        }

        if (window.location.search) {
            path += window.location.search;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const bookingToken = urlParams.get('t');

        if (bookingToken) {
            // If there's a booking token it means the user is a guest, so we need to
            // redirect to the guest bookings route
            path = path.replace('/user/bookings', '/guest/bookings');
        }

        return path;
    },

    getModificationPath: (path) => {
        if (window.location.search) {
            path += window.location.search;
        }

        return path;
    },

    getQuoteInfo: (quote) => {
        window.greenmotion.quoteInfo = Object.assign({}, window.greenmotion.quoteInfo, {
            display_currency: quote?.converted_currency,
            duration: quote?.hire_duration_in_days,
            currency: quote?.currency,
            location: {
                id: quote?.pickup_location?.data?.id,
                name: quote?.pickup_location?.data?.name,
                slug: quote?.pickup_location?.data?.slug,
                city: quote?.pickup_location?.data?.city,
                country: {
                    name: quote?.pickup_location?.data?.country?.data?.name,
                    slug: quote?.pickup_location?.data?.country?.data?.slug,
                },
            },
            payment_type: quote?.payment_type,
            selected_vehicle: {
                id: quote?.selected_vehicle?.data?.id,
                total: quote?.selected_vehicle?.data?.total,
            },
            totals: {
                total_gbp: quote?.totals?.data?.binding_pay_online_gbp,
                total_selected_currency: quote?.totals?.data?.pay_online_with_donation,
            },
        });
    },

    isPPAndPOAJourney(quote) {
        return !quote?.is_poa_only && quote?.pay_on_arrival_available;
    },

    isUsaveBrand() {
        return window.brand === 'usave';
    },

    isUsavePPAndPoaJourney(quote) {
        return this.isUsaveBrand() && this.isPPAndPOAJourney(quote);
    },

    modificationIsNotOpen(modification) {
        let confirmedOrFailedStatuses = ['confirmed', 'failed', 'payment_failed'];

        // If there's no modification, it means the user hasn't started the modification process, so we can consider the modification as not open.
        if (typeof modification === 'undefined') {
            return true;
        }

        return confirmedOrFailedStatuses.includes(modification?.status);
    },

    payNowSavingText(totals, trans) {
        var poa = totals.pay_on_arrival;
        var pp = totals.pay_online_with_donation;

        // Calculate the percentage savings
        var percent = ((poa - pp) / poa) * 100;

        if (percent > 0.0 && percent < 1.0) {
            return trans('booking-process.shared.save_by_paying_now_label');
        }

        // Only show the message if the online price is lower than the pay on arrival price
        if (pp < poa) {
            return trans('booking-process.shared.pay_now_and_save_label') + ` ${percent.toFixed(0)}%`;
        }

        // Return empty string if no savings
        return '';
    },

    poaTotal(totals) {
        return totals.pay_on_arrival;
    },
};

export default Globals;
